import { useTranslation } from 'react-i18next'

import { DragDropFileListLocal, Input, Label } from '@mercai/clever'

import { DocumentsProps } from './documents.type'

import { SectionHeader } from '../../../../components/section-header'
import styles from './documents.module.css'

export const Documents = ({
  values,
  setValues,
  onDropFile,
  position,
}: DocumentsProps) => {
  const { t } = useTranslation('screenSupplierOrderManagementComponents')

  return (
    <SectionHeader title={`${position}. ${t('componentDocumentsTitle')}`}>
      <div className={styles['info-block']}>
        <div>
          <Label>{t('componentDocumentsObservationLabel')}</Label>
          <Input
            value={values?.observation}
            onChange={(val) =>
              setValues((prev) => ({ ...prev, observation: val || '' }))
            }
            className={styles.input}
          />
        </div>
      </div>
      <div className={styles['info-block']}>
        <div className={styles['info-row-content']}>
          <div>
            <Label>{t('componentDocumentsInvoicePDFLabel')}</Label>
            <DragDropFileListLocal
              translations={{
                dragFile: t('uploadDrag'),
                sizeFile: t('uploadSize'),
                clickToUpload: t('uploadButton'),
              }}
              onDrop={(files) => onDropFile(files, 'invoicePDFFile')}
              data={values?.invoicePDFFile ? [values?.invoicePDFFile] : []}
            />
          </div>
          <div>
            <Label>{t('componentDocumentsInvoiceXMLLabel')}</Label>
            <DragDropFileListLocal
              translations={{
                dragFile: t('uploadDrag'),
                sizeFile: t('uploadSize'),
                clickToUpload: t('uploadButton'),
              }}
              onDrop={(files) => onDropFile(files, 'invoiceXMLFile')}
              data={values?.invoiceXMLFile ? [values?.invoiceXMLFile] : []}
            />
          </div>
        </div>
      </div>
    </SectionHeader>
  )
}
